import { useCallback } from 'react';
import { getWebview } from '@cian/webview/webview';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { EOs } from 'shared/types/request';

export const useWebviewSingleton = (hasDeepLink: boolean) => {
  const { config, logger, custom } = useApplicationContext();

  const MIN_IOS_VERSION = Number(config.get('promotions-flow-control.minIosVersionForWebview'));

  const isWebview = !!config.get('web.isWebView');
  const appVersion = custom.appVersion;
  const platform = custom.platform;

  const getWebviewSafe = useCallback(() => {
    if (!isWebview) {
      return null;
    }

    try {
      return getWebview();
    } catch (error) {
      logger.error(error, {
        domain: 'useWebviewSingleton',
        meta: {
          message: 'Failed to get webview',
          platform,
          appVersion,
          minIosVersion: MIN_IOS_VERSION,
        },
      });

      return null;
    }
  }, [MIN_IOS_VERSION, appVersion, isWebview, logger, platform]);

  const isAndroid = platform === EOs.Android;
  const isValidIos = platform === EOs.Ios && appVersion && Number(appVersion) >= MIN_IOS_VERSION;
  const shouldUseWebview = hasDeepLink && (isAndroid || isValidIos);

  return shouldUseWebview ? getWebviewSafe : null;
};
